<template>
  <v-container id="ContratosVer" fluid>
    <v-row justify="center">
      <v-col cols="12" class="ma-0 pa-0">
        <span style="font-size:18px"> Contratos vigentes de {{ jugador.fullName }} </span>
      </v-col>
      <v-col v-if="$can('M_contratos_crear')" cols="auto">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              fab
              color="black"
              @click="goToAltaContrato"
              v-bind="attrs"
              v-on="on"
            >
            <v-icon dark large>
              mdi-plus
            </v-icon>
          </v-btn>
          </template>
          <span>Nuevo</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-timeline align-top>
          <v-timeline-item v-for="(contrato, i) in contratosJugador" :key="i" fill-dot large color="gold">
            <base-contratos :contrato="contrato" :monedas="monedas" :index="i" @cuotasCondonadas="refrescarContrato($event)" />
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="auto">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              fab
              color="black"
              @click="goToContratosJugador"
              v-bind="attrs"
              v-on="on"
            >
            <v-icon dark large>
              mdi-text-box-multiple-outline
            </v-icon>
          </v-btn>
          </template>
          <span>Ver Todo</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'

  export default {
    props: {
      idJugador: {
        type: Number,
        required: true,
        default: 0,
      },
    },
    data () {
      return {
        contratosJugador: [],
        ir: '',
        jugador: {},
        monedas: [],
      }
    },
    created () {
      this.getContrato()
      this.getJugador()
      this.getMoneda()
    },
    methods: {
      refrescarContrato: async function (index) {
        const idContrato = this.contratosJugador[index].id
        this.$store.dispatch('axiosMod/getData', { url: '/api/contrato_jugador/' + idContrato }).then(response => {
          Vue.set(this.contratosJugador, index, response)
        })
      },
      getContrato: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/contratos_jugador/' + this.idJugador }).then(response => { this.contratosJugador = response })
      },
      getJugador: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador/' + this.idJugador }).then(response => { this.jugador = response })
      },
      getMoneda () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/moneda' }).then(response => { this.monedas = response })
      },
      goToAltaContrato: function () {
        this.$router.push({ name: 'Alta Contrato', params: { mode: 'new', idJugador: this.idJugador, idContrato: 0 } })
      },
      goToContratosJugador: function () {
        this.$router.push({ name: 'Contratos jugador', params: { Id: this.idJugador } })
      },
    },
  }
</script>
